function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
import React, { useEffect, useRef, useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import PropTypes, { string } from 'prop-types';
import { ArrowStyles, CardContainerStyles, DialogContainerStyles, IconContainer, InputFileHiddenStyles, InputImageContainer, LeftSideContainer, StyledFileContainer, StyledInputFileTextContainer, VisualizationImagesArrowsContainer, VisualizationImagesSelection, VisualizationImagesStyles, VisualizationStyles } from './InputImage.styles';
import Icon from '../Icon/Icon';
import Text from '../Text/Text';
import Button from '../Button/Button';
import Alert from '../Alert/Alert';
import Dialog from '../Dialog/Dialog';
import Card from '../Card/Card';
import Pagination from '../Pagination/Pagination';
import { elo as theme } from '../../themes';
import FileAddButton from '../Files/FileAddButton';
import File from '../Files/File';
import iconList from '../Icon/iconList';
import uuid from '../../util/uuid';
import { jsx as ___EmotionJSX } from "@emotion/core";
var InputFiles = function InputFiles(_ref) {
  var _files$currentImageIn, _files$currentImageIn2, _files$currentImageIn3;
  var title = _ref.title,
    _ref$maxFileSize = _ref.maxFileSize,
    maxFileSize = _ref$maxFileSize === void 0 ? 25 : _ref$maxFileSize,
    maxFileSizeErrorText = _ref.maxFileSizeErrorText,
    _ref$maxFileSizeError = _ref.maxFileSizeErrorTitle,
    maxFileSizeErrorTitle = _ref$maxFileSizeError === void 0 ? 'Tamanho máximo atingido' : _ref$maxFileSizeError,
    dataTestId = _ref.dataTestId,
    _ref$allowMultipleFil = _ref.allowMultipleFiles,
    allowMultipleFiles = _ref$allowMultipleFil === void 0 ? false : _ref$allowMultipleFil,
    _ref$acceptedFormats = _ref.acceptedFormats,
    acceptedFormats = _ref$acceptedFormats === void 0 ? ['jpg', 'jpeg', 'png'] : _ref$acceptedFormats,
    acceptedFormatsErrorText = _ref.acceptedFormatsErrorText,
    _ref$acceptedFormatsE = _ref.acceptedFormatsErrorTitle,
    acceptedFormatsErrorTitle = _ref$acceptedFormatsE === void 0 ? 'Não foi possível adicionar seus arquivos' : _ref$acceptedFormatsE,
    onAddFiles = _ref.onAddFiles,
    _ref$maxFiles = _ref.maxFiles,
    maxFiles = _ref$maxFiles === void 0 ? 5 : _ref$maxFiles,
    maxFilesErrorText = _ref.maxFilesErrorText,
    _ref$maxFilesErrorTit = _ref.maxFilesErrorTitle,
    maxFilesErrorTitle = _ref$maxFilesErrorTit === void 0 ? 'Número máximo de arquivos excedido' : _ref$maxFilesErrorTit,
    buttonText = _ref.buttonText,
    _ref$icon = _ref.icon,
    icon = _ref$icon === void 0 ? 'image' : _ref$icon,
    description = _ref.description,
    files = _ref.files,
    onRemoveFile = _ref.onRemoveFile,
    _ref$defaultErrorText = _ref.defaultErrorText,
    defaultErrorText = _ref$defaultErrorText === void 0 ? "Por favor, tente novamente mais tarde. \n        Se o problema persistir, entre em contato com o nosso suporte." : _ref$defaultErrorText,
    _ref$defaultErrorTitl = _ref.defaultErrorTitle,
    defaultErrorTitle = _ref$defaultErrorTitl === void 0 ? 'Não foi possível adicionar o arquivo' : _ref$defaultErrorTitl;
  var _useState = useState(null),
    currentImageIndex = _useState[0],
    setCurrentImageIndex = _useState[1];
  var _useState2 = useState(null),
    error = _useState2[0],
    setError = _useState2[1];
  var _useState3 = useState('large'),
    containerSize = _useState3[0],
    setContainerSize = _useState3[1];
  var containerRef = useRef(null);
  var inputFileRef = useRef(null);
  var isMobile = useMediaQuery({
    query: theme.breakpoints.mobile
  });
  var handleClick = function handleClick() {
    if (inputFileRef.current) {
      inputFileRef.current.click();
    }
  };
  var extractFormatsText = function extractFormatsText(array) {
    var formattedFormats = array.map(function (format) {
      return format.toUpperCase();
    });
    if (formattedFormats.length <= 2) {
      return formattedFormats.join(' ou ');
    }
    var lastFormat = formattedFormats.pop();
    return formattedFormats.join(', ') + " ou " + lastFormat;
  };
  var validateFile = function validateFile(file) {
    if (!file) {
      setError({
        title: defaultErrorTitle,
        message: defaultErrorText
      });
      return false;
    }
    var split = file.name.split('.');
    var extension = split[split.length - 1].toLowerCase();
    if (!acceptedFormats.includes(extension)) {
      setError({
        title: acceptedFormatsErrorTitle,
        message: acceptedFormatsErrorText || "Um ou mais arquivos selecionados est\xE3o com o \n        formato incompat\xEDvel. Por favor, selecione arquivos em \n        " + extractFormatsText(acceptedFormats) + "."
      });
      return false;
    }
    var fileSize = file.size / 1024 / 1024;
    if (fileSize > maxFileSize) {
      setError({
        title: maxFileSizeErrorTitle,
        message: maxFileSizeErrorText || "N\xE3o \xE9 poss\xEDvel adicionar arquivos com mais de\n        " + maxFileSize + " MB. Por favor, selecione um arquivo menor."
      });
      return false;
    }
    return true;
  };
  var addImage = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var fileList, filesArray, newFiles;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (inputFileRef != null && inputFileRef.current) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return");
          case 2:
            fileList = inputFileRef.current.files;
            filesArray = Array.from(fileList);
            if (!(filesArray.length + files.length > maxFiles)) {
              _context.next = 7;
              break;
            }
            setError({
              title: maxFilesErrorTitle,
              message: maxFilesErrorText || "Voc\xEA pode adicionar no m\xE1ximo " + maxFiles + " \n        arquivos. Por favor, reduza a quantidade e \n        tente novamente."
            });
            return _context.abrupt("return");
          case 7:
            newFiles = filesArray.filter(validateFile).map(function (file, index) {
              var _file$type;
              var id = uuid();
              return {
                name: file.name,
                type: file.type,
                size: file.size,
                buffer: file,
                id: id,
                src: file instanceof Blob ? URL.createObjectURL(file) : null,
                onRemoveClick: function onRemoveClick() {
                  return onRemoveFile(id);
                },
                onClick: (_file$type = file.type) != null && _file$type.includes('image') ? function () {
                  return setCurrentImageIndex(index);
                } : null,
                dataTestId: dataTestId + "-file-" + id
              };
            });
            if (onAddFiles) {
              onAddFiles(newFiles);
            }
            if (inputFileRef.current) {
              inputFileRef.current.value = '';
            }
          case 10:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function addImage() {
      return _ref2.apply(this, arguments);
    };
  }();
  useEffect(function () {
    var currentContainer = containerRef.current;
    var resizeObserver = new ResizeObserver(function (_ref3) {
      var entry = _ref3[0];
      var width = entry.contentRect.width;
      setContainerSize(width < 500 ? 'small' : 'large');
    });
    if (currentContainer) {
      resizeObserver.observe(currentContainer);
    }
    return function () {
      if (currentContainer) {
        resizeObserver.unobserve(currentContainer);
      }
    };
  }, []);
  return ___EmotionJSX(React.Fragment, null, error && ___EmotionJSX(Alert, {
    title: error.title,
    primaryButtonText: "Fechar",
    onPrimaryClick: function onPrimaryClick() {
      return setError(null);
    },
    onClose: function onClose() {
      return setError(null);
    },
    secondaryButtonText: "",
    variant: "negative"
  }, error.message), ___EmotionJSX(InputFileHiddenStyles, {
    "data-test-id": dataTestId,
    type: "file",
    tabIndex: "-1",
    ref: function ref(node) {
      inputFileRef.current = node;
    },
    onChange: addImage,
    multiple: allowMultipleFiles,
    accept: acceptedFormats.map(function (format) {
      return "." + format;
    }).join(', ')
  }), currentImageIndex !== null && ___EmotionJSX(Dialog, {
    title: (_files$currentImageIn = files[currentImageIndex]) == null ? void 0 : _files$currentImageIn.name,
    onClose: function onClose() {
      return setCurrentImageIndex(null);
    },
    size: "large"
  }, ___EmotionJSX(DialogContainerStyles, null, ___EmotionJSX(ArrowStyles, {
    style: {
      left: isMobile ? '8px' : '0',
      visibility: currentImageIndex > 0 ? 'inherit' : 'hidden'
    },
    onClick: function onClick() {
      return setCurrentImageIndex(function (index) {
        return index - 1;
      });
    }
  }, ___EmotionJSX(Icon, {
    type: "chevron-left",
    variant: "brand"
  })), ___EmotionJSX(CardContainerStyles, null, ___EmotionJSX(Card, {
    secondary: true
  }, ___EmotionJSX(VisualizationImagesArrowsContainer, null, ___EmotionJSX(VisualizationStyles, {
    src: (_files$currentImageIn2 = files[currentImageIndex]) == null ? void 0 : _files$currentImageIn2.src,
    alt: (_files$currentImageIn3 = files[currentImageIndex]) == null ? void 0 : _files$currentImageIn3.name
  })))), ___EmotionJSX(ArrowStyles, {
    style: {
      right: isMobile ? '8px' : '0',
      visibility: currentImageIndex < files.length - 1 ? 'inherit' : 'hidden'
    },
    onClick: function onClick() {
      return setCurrentImageIndex(function (index) {
        return index + 1;
      });
    }
  }, ___EmotionJSX(Icon, {
    type: "chevron-right",
    variant: "brand"
  }))), ___EmotionJSX(VisualizationImagesSelection, {
    style: {
      margin: isMobile ? theme.spacings.xxSmall + " auto 0" : ''
    }
  }, isMobile ? ___EmotionJSX(Pagination, {
    initialPage: currentImageIndex + 1,
    itemsPerPage: 1,
    totalItems: files.length,
    type: "mobile",
    onClickMobilePageItem: function onClickMobilePageItem(e) {
      return setCurrentImageIndex(e - 1);
    }
  }) : files.map(function (file, i) {
    return ___EmotionJSX(VisualizationImagesStyles, {
      key: i,
      onClick: function onClick() {
        return setCurrentImageIndex(i);
      },
      style: {
        backgroundImage: "url(" + (file == null ? void 0 : file.src) + ")",
        border: currentImageIndex === i ? "2px solid " + theme.colors.brand40 : "2px solid " + theme.colors.shade20
      }
    });
  }))), ___EmotionJSX("div", {
    ref: containerRef
  }, !files.length ? ___EmotionJSX(InputImageContainer, {
    containerSize: containerSize
  }, ___EmotionJSX(LeftSideContainer, {
    containerSize: containerSize
  }, ___EmotionJSX(IconContainer, null, ___EmotionJSX(Icon, {
    type: icon,
    secondary: true
  })), ___EmotionJSX(StyledInputFileTextContainer, {
    isContainerSizeSmall: containerSize === 'small'
  }, title && ___EmotionJSX(Text, {
    size: "t2",
    semibold: true,
    display: "flex"
  }, title), description && ___EmotionJSX(Text, {
    size: "t3",
    secondary: true
  }, description))), ___EmotionJSX(Button, {
    dataTestId: dataTestId + "-button",
    secondary: true,
    onClick: handleClick,
    size: isMobile ? 'large' : 'medium',
    fullWidth: containerSize === 'small'
  }, ___EmotionJSX(Text, {
    size: "t2",
    bold: true,
    alignment: "center",
    element: "span",
    variant: "brand"
  }, buttonText))) : ___EmotionJSX(StyledFileContainer, null, ___EmotionJSX(React.Fragment, null, files.map(function (file) {
    return ___EmotionJSX(File, _extends({
      key: file.id
    }, file));
  })), allowMultipleFiles && files.length < maxFiles && ___EmotionJSX(FileAddButton, {
    onClick: handleClick
  }))));
};
InputFiles.propTypes = {
  dataTestId: PropTypes.string,
  maxFileSize: PropTypes.number,
  maxFileSizeErrorText: PropTypes.string,
  onAddFiles: PropTypes.func,
  title: PropTypes.string.isRequired,
  allowMultipleFiles: PropTypes.bool,
  acceptedFormats: PropTypes.arrayOf(string),
  acceptedFormatsErrorText: PropTypes.string,
  maxFiles: PropTypes.number,
  maxFilesErrorText: PropTypes.string,
  maxFilesErrorTitle: PropTypes.string,
  buttonText: PropTypes.string.isRequired,
  icon: PropTypes.oneOf([].concat(Object.keys(iconList), [''])),
  description: PropTypes.string,
  files: PropTypes.arrayOf(PropTypes.shape({
    file: PropTypes.object,
    id: PropTypes.string,
    src: PropTypes.string,
    type: PropTypes.string,
    size: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
    loading: PropTypes.bool,
    variant: PropTypes.oneOf(['negative']),
    maxWidth: PropTypes.string,
    onClick: PropTypes.func,
    onRemoveClick: PropTypes.func,
    dataTestId: PropTypes.string,
    buffer: PropTypes.object
  })).isRequired,
  onRemoveFile: PropTypes.func,
  defaultErrorText: PropTypes.string,
  defaultErrorTitle: PropTypes.string,
  maxFileSizeErrorTitle: PropTypes.string,
  acceptedFormatsErrorTitle: PropTypes.string
};
export default InputFiles;